// user.actions.ts
import { createAction, props } from '@ngrx/store';

const setToken = createAction('setToken', props<{ token: string }>());
const clearToken = createAction('clearToken');
const setUser = createAction('[Auth] Set User Data', props<{ user: any }>());
const clearUser = createAction('[Auth] Clear User Data');

export default {
    setToken,
    clearToken,
    setUser,
    clearUser
}